import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import HomePageTechnicalSvg from '@Components/HomePageBox/home_page_background.svg';
import Box from '@mui/material/Box';
import { VerticeLogo, WHITE } from "@Components/VerticeLogo";
const HomePageBox = () => {
    return (_jsx(_Fragment, { children: _jsx(Box, { sx: {
                width: "100%",
                height: "100%",
                backgroundColor: "#FFFFFF",
            }, children: _jsx(Box, { sx: {
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#000000CC",
                    backgroundImage: `url(${HomePageTechnicalSvg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "center",
                }, children: _jsx(VerticeLogo, { width: '913px', height: '174px', color: WHITE }) }) }) }));
};
export default HomePageBox;
